import {
  CalendarEventDetails,
  ExternalCalendarEventPreview,
  TranslateFunction,
} from '@griply/types';

import { getVideoCallProviderNameKey } from './get-video-call-provider-name-key';

export type CalendarEventVideoCallSource = Pick<
  CalendarEventDetails,
  'videoCallUrl' | 'videoCallProvider' | 'videoCallProviderName'
>;

export type CalendarEventVideoCall = {
  url?: string | null;
  label: string;
};

// The provider's own conference label is getEvent-only; until then the events-list enum names it.
export const getCalendarEventVideoCall = (
  details: CalendarEventVideoCallSource | null | undefined,
  preview: ExternalCalendarEventPreview | undefined,
  t: TranslateFunction,
): CalendarEventVideoCall => ({
  url: details?.videoCallUrl ?? preview?.videoCallUrl,
  label:
    details?.videoCallProviderName ||
    t(
      getVideoCallProviderNameKey(
        details?.videoCallProvider ?? preview?.videoCallProvider,
      ),
    ),
});
